<template>
  <div
    id="app"
    style="overflow: hidden"
    v-loading="loading"
    element-loading-text="正在加载中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)"
  >
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    window._loading = (loading) => (this.loading = loading);

    let start = new Date().getTime();
    let str = "";
    let f = (e) => {
      let sf = window.top._Scan2Input;
      let now = new Date().getTime();
      //console.log(e.key);
      if (str == "" || (now - start < 200 && e.key != "Enter")) {
        //console.log("time=" + (now - start));
        if (e.key.length == 1) {
          start = now;
          str += e.key;
        }
      } else {
        if (sf) {
          console.log("输入：" + str);
          sf(str);
        }
        str = "";
      }
    };

    window.$(document).keydown(f);
  },

  
};
</script>

<style>
#app .el-loading-mask {
  z-index: 9999;
}

.auto {
  display: flex;
  align-items: center;
  .el-form-item {
    display: inline-block;
    width: auto !important;
  }
}
.toolbar-btn {
  margin-left: 10px;
}
.margin-top-10 {
  margin-top: 10px;
}

/* 自定义滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 10px;
  background-color: #f5f5f5;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  background-color: #f5f5f5;
}
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #6bccff;
}

/* 自定义右键菜单 */
.contextMenu {
  position: absolute;
  padding: 2px 4px;
  margin: 0;
  font-size: 14px;
  color: #000000;
  border-radius: 5px;
  z-index: 1000;
  min-width: 200px;
  background-color: #ffffff;
  border: 1px solid transparent;
  box-shadow: 2px 5px 16px -4px #141321;
}
.contextMenu .menu-item {
  padding: 4px 8px;
  border-radius: 3px;
  border: none;
  display: block;
  width: 100%;
  text-align: left;
  background-color: transparent;
}
.contextMenu .menu-item:first-child {
  margin-top: 5px;
}
.contextMenu .menu-item:hover {
  cursor: pointer;
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}
.specialBg .el-input__inner {
  background-color: #f5f5f5;
}
</style>



